module.exports = __webpack_public_path__ + "01_face.b8e59c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer1/01_face.png
// module id = nTom
// module chunks = 0